export function formatCurrency(amount, currency = 'GHS') {
    return new Intl.NumberFormat('en-GH', { style: 'currency', currency }).format(amount);
}
export function getInitials(name) {
    return name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
}
export function delay(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}
